export const generateItemCIDKey = ({
  orgId,
  streamId,
  channelId,
  streamItemId,
  id,
}) => {
  if (streamItemId) {
    return [orgId, streamId, channelId, streamItemId].join('/');
  }

  return [orgId, streamId, channelId, id].join('/');
};
